import type { IPermissionsRepository } from "@domain/repositories";
import { TYPES } from "@utils/inversifyJS/types";
import { inject, injectable } from "inversify";
import type { MePermissions, PermissionScope } from "@domain/schemas/workspace";

@injectable()
export class GetMyPermissionsService {
  @inject(TYPES.IPermissionsRepository)
  private _permissionsRepository!: IPermissionsRepository;

  async getMyPermissionsAsync(scope: PermissionScope): Promise<MePermissions> {
    return this._permissionsRepository.getMyPermissionsAsync(scope);
  }
}
